import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.css'
})
export class ConfirmationModalComponent {

  @Input() confirmationText: string = '¿Seguro que deseas desbloquear a este usuario?';
  @Input() isVisible: boolean = false;
  @Input() confirmButtonText: string = ''
  @Input() confirmationType: string = ''
  @Input() valueToCopy: any = ''
  @Input() showCancelButton: boolean = true
  textToCopy = 'Este es el texto que será copiado';
  copySuccess = false;
  @Output() confirmed: EventEmitter<void> = new EventEmitter();
  @Output() canceled: EventEmitter<void> = new EventEmitter();

  closeModal() {
    this.isVisible = false;
    this.canceled.emit();
  }
  onCancel() {
    this.isVisible = false;
    this.canceled.emit();
  }
  onConfirm() {
    this.isVisible = false;
    this.confirmed.emit();
  }
  copyToClipboard() {
    const textToCopy = this.valueToCopy
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.copySuccess = true;
      // setTimeout(() => {
      //   this.copySuccess = false;
      // }, 2000); 
    }).catch((err) => {
      console.error('Error al copiar al portapapeles:', err);
    });
  }

}
